import { UpdateNotificationsSettingsDto,UserNotificationsSettings } from '@/common/api/datasources/Api';
import { api } from '@/common/api/instance';

export const userNotificationsSettingsService = {
    getSettings: async (): Promise<UserNotificationsSettings> => {
        const response = await api.usersNotificationsSettings.userNotificationsSettingsControllerGetSettings();
        return response.data;
    },

    updateSettings: async (data: UpdateNotificationsSettingsDto): Promise<UserNotificationsSettings> => {
        const response = await api.usersNotificationsSettings.userNotificationsSettingsControllerUpdateSettings(data);
        return response.data;
    },
};

export const useUserNotificationsSettingsQuery = () => ({
    settingsQuery: {
        queryKey: ['user-notifications-settings'],
        queryFn: () => userNotificationsSettingsService.getSettings(),
        enabled: true,
        retry: 1,
    },

    
    updateSettingsMutation: {
        mutationFn: (data: UpdateNotificationsSettingsDto) => userNotificationsSettingsService.updateSettings(data),
    },
}); 